import GrComponentFactory from "../gr_component_factory";
import React from "react";
import { map } from "lodash";
import ToSentence from "../../modules/to_sentence";

export default GrComponentFactory.createClass({
  displayName: "ChoiceWidget",
  mixins: [ToSentence],
  propTypes: {
    badgeUrl: React.PropTypes.string.isRequired,
    choiceAwardsUrl: React.PropTypes.string.isRequired,
    flourishUrl: React.PropTypes.string.isRequired,
    friendsWhoVoted: React.PropTypes.array,
    numOtherFriends: React.PropTypes.number,
    numVotesCast: React.PropTypes.string.isRequired,
    winnersAnnounced: React.PropTypes.bool.isRequired,
    choiceYear: React.PropTypes.number.isRequired,
  },

  renderTitle() {
    return (
      <div className="choiceWidget__title">
        <span className="choiceWidget__titleWhite u-displayBlock">{ this.props.winnersAnnounced ? "Announcing" : "Decide" } Readers' </span>
        <span className="choiceWidget__titleWhite u-displayBlock">Favorite Books of { this.props.choiceYear }</span>
      </div>
    );
  },

  renderNumVotesCast() {
    return <div className="choiceWidget__votesCast">
      { this.props.numVotesCast } Votes Cast
    </div>;
  },

  renderFriendLink(friend) {
    return <a className="choiceWidget__votesCast" href={friend.url}>{friend.name}</a>;
  },

  renderOtherFriendsText() {
    return <span>
      {this.props.numOtherFriends} other
      {(this.props.numOtherFriends == 1) ? " friend" : " friends" }
    </span>;
  },

  renderFriendsWhoVoted() {
    if (!this.props.friendsWhoVoted) {
      return null;
    }
    const friendLinks = map(this.props.friendsWhoVoted, (friend) => this.renderFriendLink(friend));
    if (this.props.numOtherFriends > 0) {
      friendLinks.push(this.renderOtherFriendsText());
    }
    return <div className="choiceWidget__votesCast">
      { this.toSentence(friendLinks) }
      { this.props.friendsWhoVoted.length == 1 ? " has " : " have "}
      voted.
    </div>;
  },

  renderButtonText() {
    return this.props.winnersAnnounced ? "See the Winners" : "Cast Your Vote";
  },

  renderBadge() {
    return <a href={this.props.choiceAwardsUrl}>
      <img className=""
        src={this.props.badgeUrl}
        alt={"Goodreads Choice Awards"} />
    </a>;
  },

  render() {
    return <div className="choiceWidget">
      <h3 className="gr-h3 gr-h3--noTopMargin">
        Goodreads Choice Awards
      </h3>
      <div className="choiceWidget__photoAndTextContainer">
        <div className="gr-mediaFlexbox__media">
          { this.renderBadge() }
        </div>
        <div className="choiceWidget__titleAndButtonContainer">
          <div>
            { this.renderTitle() }
          </div>
          <a className="gr-button gr-button--fullWidth choiceWidget__seeWinnersButton gr-button--choice"
            href={this.props.choiceAwardsUrl}>
            {this.renderButtonText()}
          </a>
          <div className="gr-mediaFlexbox u-marginBottomXSmall">
            <div className="gr-mediaFlexbox__desc u-marginRightTiny">
              { this.renderNumVotesCast() }
              { this.renderFriendsWhoVoted() }
            </div>
          </div>
        </div>
      </div>
    </div>;
  },
});
